// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum NOTIFICATION_GROUP_TYPE {
    annotation = 'annotation',
    general = 'general',
}
